export default __webpack_public_path__ + "static/media/calendar-birthday.db789b2d.svg";